module.exports = __webpack_public_path__ + "static/media/fastDelivery.ab4ad7da.png";